import { APP_TRANSACTION, TRANSACTION_HISTORY } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IBalanceRegistrationRepository } from "features/balanceRegistration/domain/repositories/IBalanceRegistrationRepository";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { StringFormat } from "utils/format/StringFormat";
import { BalanceRegistrationDetailModel } from "./model/BalanceRegistrationDetailModel";
import { BalanceRegistrationRequestModel } from "./model/BalanceRegistrationRequestModel";
import { BalanceRegistrationResponseModel } from "./model/BalanceRegistrationResponseModel";

@injectable()
export class BalanceRegistrationImpl implements IBalanceRegistrationRepository {
  async getList(
    params: BalanceRegistrationRequestModel,
    usePrivateList = false
  ): Promise<ListBaseApiResponseModel<BalanceRegistrationResponseModel>> {
    const url = StringFormat.buildListUrl<BalanceRegistrationRequestModel>(
      usePrivateList
        ? TRANSACTION_HISTORY.PRIVATE_LIST
        : TRANSACTION_HISTORY.BALANCELIST,
      params
    );
    const preparedParams = DataFormat.prepareParamsForApi(params);
    return await client?.get(url, preparedParams);
  }

  async getDetail(
    params: BalanceRegistrationRequestModel,
    usePrivateList = false
  ): Promise<BaseApiResponseModel<BalanceRegistrationDetailModel>> {
    return await client?.get(
      usePrivateList
        ? TRANSACTION_HISTORY.PRIVATE_TRANS_DETAIL
        : APP_TRANSACTION.DETAIL,
      params
    );
  }

  async exportReport(
    params: BalanceRegistrationRequestModel,
    usePrivateList = false
  ): Promise<BaseApiResponseModel<Blob>> {
    const url = StringFormat.buildExportUrl(
      usePrivateList
        ? TRANSACTION_HISTORY.PRIVATE_LIST
        : TRANSACTION_HISTORY.BALANCELIST,
      params
    );
    const token = DataFormat.getToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-export": "excel",
        "Content-Type": "application/xml",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorBody = await response.json();
      return errorBody;
    }

    const blob = await response.blob();

    return {
      success: true,
      data: blob,
      message: "Export successful",
    } as unknown as BaseApiResponseModel<Blob>;
  }
}
